interface DataConfig {
  key: string;
  graph: string;
  transform: (data: any, fullData?: any) => any;
  gridColDef?: any[];
}

export const previewScheduleCallAnalyticsDataConfigs: DataConfig[] = [
  {
    key: 'schedule_statistics_overview.total_scheduled_meetings',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Total Meetings',
      value: data?.toString() || '0',
      changeType: 'positive',
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      accentColor: '#667eea'
    })
  },
  {
    key: 'schedule_statistics_overview.scheduled',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Upcoming Calls',
      value: data || '0',
      changeType: 'positive',
      gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
      accentColor: '#4facfe'
    })
  },
  {
    key: 'schedule_statistics_overview.ongoing',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Ongoing Calls',
      value: data || '0',
      changeType: 'positive',
      gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      accentColor: '#93fbb7'
    })
  },
  {
    key: 'schedule_statistics_overview.completed',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Completed Calls',
      value: data || '0',
      changeType: 'positive',
      gradient: 'linear-gradient(135deg, #10B981 0%, #34D399 100%)',
      accentColor: '#10B981'
    })
  },
  {
    key: 'schedule_statistics_overview.cancelled',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Cancelled Calls',
      value: data || '0',
      changeType: 'positive',
      gradient: 'linear-gradient(135deg, #EF4444 0%, #F87171 100%)',
      accentColor: '#EF4444'
    })
  },
  {
    key: 'schedule_statistics_overview.expired',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Expired Calls',
      value: data || '0',
      changeType: 'positive',
      gradient: 'linear-gradient(135deg, #F59E0B 0%, #FBBF24 100%)',
      accentColor: '#F59E0B'
    })
  },
  {
    key: 'schedule_statistics_overview.total_meeting_duration',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Total Meeting Duration',
      value: data || '0m 0s',
      changeType: 'positive',
      gradient: 'linear-gradient(135deg, #3B82F6 0%, #60A5FA 100%)',
      accentColor: '#3B82F6'
    })
  },
  {
    key: 'schedule_statistics_overview.average_meeting_duration',
    graph: 'MetricCard',
    transform: (data: any, fullData: any) => ({
      title: 'Average Duration',
      value: data || '0m 0s',
      changeType: 'positive',
      gradient: 'linear-gradient(135deg, #8B5CF6 0%, #A78BFA 100%)',
      accentColor: '#8B5CF6'
    })
  },
  {
    key: 'schedule_status_distribution',
    graph: 'DonutChart',
    transform: (data: any, fullData?: any) => {
      return (
        fullData?.schedule_status_distribution?.chart_data?.map(
          (item: any) => ({
            name: item.name,
            value: item.value,
            color: item.color
          })
        ) || []);
    }
  },
  {
    key: 'schedule_calls_by_date',
    graph: 'AreaChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      scheduled: item.scheduled,
      held: item.held,
    })) || []
  },
  {
    key: 'schedule_call_type_distribution',
    graph: 'PieChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      name: item.name,
      value: item.count,
      color: item.color
    })) || [],
  },
  {
    key: 'schedule_call_duration_distribution',
    graph: 'BarChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      duration: item.duration,
      count: item.count
    })) || []
  },
  {
    key: 'booking_lead_time',
    graph: 'BarChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      duration: item.range,
      count: item.count
    })) || []
  },
  {
    key: 'schedule_calls_heatmap',
    graph: 'HeatMap',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      hour: item.hour,
      value: item.value
    })) || [],
  },
  {
    key: 'top_meeting_creators',
    graph: 'DonutChart',
    transform: (data: any, fullData?: any) => {
      return (
        fullData?.top_meeting_creators?.chart_data?.map(
          (item: any) => ({
            name: item.user_name,
            value: item.total_meetings,
            color: item.color,
            user_id: item.user_id
          })
        ) || []);
    }
  },
  {
    key: 'bookings_over_time',
    graph: 'AreaChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      date: item.date,
      scheduled: item.scheduled,
      completed: item.completed,
      cancelled: item.cancelled,
      expired: item.expired,
      ongoing: item.ongoing,
      total: item.total
    })) || []
  },
  {
    key: 'schedule_punctuality_analysis',
    graph: 'BarChart',
    transform: (data: any) => data?.chart_data?.map((item: any) => ({
      name: item.name,
      count: item.count
    })) || []
  },
];